export default __webpack_public_path__ + "static/media/greenArrowUp.52757b12.svg";